/*
  13/10/2026 — thẻ add-on (hộp quà…) cho option Checkbox của Customily có function
  "Add Shopify Product". Customily chỉ vẽ một checkbox trơn; file này bọc nó thành thẻ:
  tiêu đề, ảnh, giá (kèm giá gạch nếu sản phẩm có compare-at), một câu mô tả, ô "Choose to buy".

  Dữ liệu lấy từ chính sản phẩm add-on (/products/<handle>.js) nên đổi ảnh/giá/mô tả trong
  Shopify admin là thẻ tự theo. Không di chuyển node của Customily — chỉ chèn thêm anh em và
  xếp bằng CSS grid, nên Customily vẽ lại thì chỉ cần chèn lại.

  Hỏng thì im: không đọc được cấu hình hoặc sản phẩm thì checkbox giữ nguyên dạng gốc.
*/
(function () {
  var cache = {};
  var configPromise;

  function loadSets() {
    if (configPromise) return configPromise;
    var inline = window.customily && window.customily.product && window.customily.product.sets;
    if (inline) return (configPromise = Promise.resolve(inline));
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m || !window.Shopify || !Shopify.shop) return (configPromise = Promise.resolve([]));
    configPromise = fetch('https://sh.customily.com/api/settings/unified/' + m[1] + '?shop=' + Shopify.shop)
      .then(function (r) { return r.json(); })
      .then(function (d) { return d.sets || []; })
      .catch(function () { return []; });
    return configPromise;
  }

  function loadProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function money(cents) {
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: code }).format(cents / 100) + ' ' + code;
    } catch (e) {
      return '$' + (cents / 100).toFixed(2) + ' ' + code;
    }
  }

  function firstSentence(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    var t = (d.textContent || '').replace(/\s+/g, ' ').trim();
    var m = t.match(/^.*?[.!?](\s|$)/);
    return (m ? m[0] : t).trim();
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function decorate(acc, handle, variantId) {
    if (acc.querySelector(':scope > .pf-addon__title')) return;
    loadProduct(handle).then(function (p) {
      if (!p || acc.querySelector(':scope > .pf-addon__title')) return;
      var box = acc.querySelector('.checkbox-container');
      if (!box) return;
      var v = p.variants.filter(function (x) { return String(x.id) === String(variantId); })[0] || p.variants[0];

      var title = el('div', 'pf-addon__title', 'Add-On ' + p.title);
      var media = el('div', 'pf-addon__media');
      if (p.featured_image) {
        var img = document.createElement('img');
        img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200';
        img.alt = p.title;
        img.loading = 'lazy';
        media.appendChild(img);
      } else {
        media.classList.add('pf-addon__media--empty');
        media.innerHTML = '<svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';
      }
      var info = el('div', 'pf-addon__info');
      var price = el('div', 'pf-addon__price');
      price.appendChild(document.createTextNode('Only '));
      if (false && v.compare_at_price && v.compare_at_price > v.price) { /* 24/10: chỉ 1 giá */
        price.appendChild(el('s', '', money(v.compare_at_price)));
        price.appendChild(document.createTextNode(' '));
      }
      price.appendChild(el('b', '', money(v.price)));
      info.appendChild(price);
      var desc = firstSentence(p.description);
      if (desc) info.appendChild(el('div', 'pf-addon__desc', desc));

      acc.classList.add('pf-addon');
      acc.insertBefore(title, acc.firstChild);
      acc.insertBefore(media, box);
      acc.insertBefore(info, box);
      performance.mark('pf-addon-done');
    });
  }

  function scan() {
    var nodes = document.querySelectorAll('.customily_option.cl-has-checkbox > .cl-option-content:not(.pf-addon)');
    if (!nodes.length) return;
    if (!scan.seen) { scan.seen = true; performance.mark('pf-addon-seen'); }
    loadSets().then(function (sets) {
      nodes.forEach(function (acc) {
        for (var i = 0; i < sets.length; i++) {
          var prefix = 'cl-option-accordion-' + sets[i].id + '-';
          if (acc.id.indexOf(prefix) !== 0) continue;
          var optId = acc.id.slice(prefix.length);
          var opt = (sets[i].options || []).filter(function (o) { return String(o.id) === optId; })[0];
          var fn = opt && (opt.functions || []).filter(function (f) { return f.type === 'shProduct' && f.shProducts && f.shProducts.length; })[0];
          if (fn) decorate(acc, fn.shProducts[0].handle, fn.shProducts[0].variantId);
        }
      });
    });
  }

  /* Gom theo khung hình, KHÔNG debounce: Customily dựng widget bằng hàng trăm mutation liên
     tiếp, debounce 150ms bị đặt lại mãi nên thẻ chỉ hiện khi trang đã yên hẳn (13/10/2026). */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  }

  /* Tải sẵn sản phẩm add-on trong lúc Customily còn đang dựng widget, để khi checkbox
     xuất hiện là có dữ liệu vẽ thẻ ngay. */
  function prefetch() {
    /* Chỉ dùng cấu hình in sẵn trong trang — không gọi mạng ở đây, kẻo mọi trang sản phẩm
       (kể cả trang không có add-on) đều tốn thêm một request. */
    var inline = window.customily && window.customily.product && window.customily.product.sets;
    if (!inline) return;
    Promise.resolve(inline).then(function (sets) {
      sets.forEach(function (set) {
        (set.options || []).forEach(function (o) {
          (o.functions || []).forEach(function (f) {
            if (f.type === 'shProduct' && f.shProducts && f.shProducts.length) loadProduct(f.shProducts[0].handle);
          });
        });
      });
    });
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  prefetch();
  schedule();
})();
